export default __webpack_public_path__ + "static/media/group3.c40f1f3a.png";